import Card from "../Card";
import SecondaryButton from "../SecondaryButton/SecondaryButton";

export default function ExploreSpheron({
  isEligible,
}: {
  isEligible: boolean;
}) {
  return (
    <Card
      className={
        "!py-6 flex-col gap-4 " +
        (isEligible ? "w-full" : "w-[512px] !bg-[#141416] ")
      }
    >
      {!isEligible && (
        <>
          <h3 className="text-white text-2xl uppercase tracking-wider">Don't worry</h3>
          <p className="text-base text-[#9D9D9D] -mt-2">
            You can still be part of the decentralized compute revolution.
          </p>
        </>
      )}
      {isEligible && (
        <>
          <h3 className="text-white text-2xl uppercase tracking-wider">Explore the Spheron Ecosystem</h3>
          <p className="text-base text-[#9D9D9D] -mt-2 text-center">
            Unlock even more possibilities! Dive into the Spheron ecosystem to
            discover products, resources, and opportunities designed for
            innovators like you.
          </p>
        </>
      )}
      <SecondaryButton
        variant={"light"}
        onClick={() => window.open("https://spheron.network", "_blank")}
      >
        Explore Spheron Network
      </SecondaryButton>
    </Card>
  );
}
